import styles from "./index.module.css";
import ProjectBox, { Filters } from "./ProjectBox";

interface ProjectDetails{
  icon_path: string;
  alt_name:string;
  name: string;
  catchphrase: string;
  bulletpoints: Array<string>;
  github_link: string;
  languages: Array<Filters>;
  packages: Array<Filters>;
}



const PACKAGES: Array<Filters> = [
  {
    name: "NumPy",
    color: "#ACE38D",
  },
  {
    name:"CV2",
    color:"#ACE38D",
  },
  {
    name: "TensorFlow",
    color: "#ACE38D",
  },
  {
    name: "JavaFX - Animation",
    color: "#F88F46",
  },
  {
    name: "Shapes",
    color: "#F88F46",
  },
  {
    name: "Selenium",
    color: "#ACE38D",
  },
  {
    name: "requests",
    color: "#ACE38D",
  },
  {
    name:"Pandas",
    color: "#ACE38D",
  },
  {
    name:"PyGame",
    color: "#ACE38D",
  },
  {
    name: "sqlite3",
    color:"#c170e0",
  },
  {
    name: "matplotlib",
    color:"#ACE38D"
  },
  {
    name:"d3.js",
    color:"#c170e0"
  },
  {
    name:"Math",
    color:"#c170e0"
  },
  { name:"TopoJSON",
    color:"#c170e0"
  },
  {
    name:"Normalize.css",
    color:"#e65e5e"
  },
  {
    name: "JSON",
    color: "#ACE38D",
  },
  {
    name: "signal.h",
    color:"#3c92e6",
  },
  {
    name: "stdio.h",
    color:"#3c92e6",
  },
  {
    name: "sys/wait.h",
    color:"#3c92e6",
  },
  {
    name:"sys/types.h",
    color:"#3c92e6",
  },
  {
    name:"stdlib.h",
    color:"#3c92e6",
  },
  {
    name: "unistd.h",
    color: "#3c92e6"
  },
  {
    name: "JavaFX - Scene",
    color: "#F88F46",
  },
  {
    name: "JavaFX - Events",
    color: "#F88F46",
  },
  {
    name: "StrictMath",
    color: "#F88F46",
  },
  {
    name: "Time",
    color:"#ACE38D"
  },
  {
    name: "LiquidCrystal.h",
    color: "#3c92e6"
  },
  {
    name: "Servo.h",
    color: "#3c92e6"
  },
  {
    name: "GCLK Register",
    color: "#3c92e6"
  },
  {
    name: "TC3 Register",
    color: "#3c92e6"
  },
  {
    name: "Watch Dog Timer",
    color: "#3c92e6"
  },
  {
    name: "open3d",
    color: "#ACE38D"

  },
  {
    name: "bosdyn.client",
    color: "#ACE38D"

  },
  {
    name: "rospy",
    color: "#ACE38D"
  },
  {
    name: "PyTorch",
    color: "#ACE38D",
  },
  {
    name: "Google MediaPipe",
    color: "#ACE38D",
  }

];

const FILTERS: Array<Filters> = [
  {
    name: "Python",
    color: "#6BB243",
  },
  {
    name: "Java",
    color: "#F76906",
  },

  {
    name: "JavaScript",
    color: "#9619C9",
  },
  {
    name: "React",
    color: "#3D95CB",
  },
  {
    name: "C",
    color: "#003970",
  },
  {
    name: "SQLite",
    color: "#9619C9",
  },
  {
    name: "MATLAB",
    color: "#c9be2c",
  },
  {
    name: "HTML/CSS",
    color: "#d10d0d",
  },
  {
    name: "Makefile",
    color: "#003970",
  },  
  {
    name: "C++",
    color: "#003970",
  }

];

const PROJECT_DETAILS:  Array<ProjectDetails> = [
  {
    icon_path: "media/video_db.png",
    alt_name:"VideoDB",
    name: "Video Analytics using Natural Language",
    catchphrase: "SQL | MySQL | CLIP | CLIPCap | GPT4-o",
    bulletpoints: ['Developed a video search system combining SQL retrieval with multimodal similarity search for natural language queries', 'Designed a dynamic schema that populates unseen attributes in user queries'],
    github_link: "https://www.github.com",
    languages:[FILTERS[0]],
    packages:[PACKAGES[2],PACKAGES[31],PACKAGES[32],PACKAGES[0]]
  },
  {
    icon_path: "media/slang_icon.png",
    alt_name:"SLANG",
    name: "SLANG: Spot & Langauge",
    catchphrase: "Spot Robot | ClipSeg | ROS | PointCloud",
    bulletpoints: ['Integrated ClipSeg with a Spot robot for grasping arbitrary objects in an observed scene specified in natural language with modifiers e.g. “the large green cup”, “something healthy to eat”' ],
    github_link: "https://www.github.com",
    languages:[FILTERS[0]],
    packages:[PACKAGES[2],PACKAGES[31],PACKAGES[32],PACKAGES[0]]
  },

  {
    icon_path: "media/pidrone_icon.png",
    alt_name:"PiDrone",
    name: "RaspberryPi Drone",
    catchphrase: "ROS System | Raspberry Pi | PID Controller | Visual SLAM | Optical Flow",
    bulletpoints: ['Built, soldered and coded a drone using Raspberry Pi and ROS subscribers / publishers', 'Drone supports PID controller for autonomous altitude stabilization, optical flow estimation and visual SLAM localization using Unscented Kalman-Filters' ],
    github_link: "https://github.com/Shreyas-S-Raman/duckietown-lx",
    languages:[FILTERS[0], FILTERS[9]],
    packages:[PACKAGES[1], PACKAGES[10], PACKAGES[0], PACKAGES[33]]
  },

  {
    icon_path: "media/chromalock_icon.png",
    alt_name:"ChromaLock",
    name: "Chroma Lock: Key Pad Lock",
    catchphrase: "Arduino | Embedded Systems | LCD Display Output",
    bulletpoints: ['Numeric key-pad lock with an Arduino UNO, servo motors and capacitance buttons', 'Padlock supports passcode resets, 3 max passcode tries with lock timeouts, watchdog timer for idle autolocking, variable passcode lengths (upto 10 characters) and visual audio feedback'],
    github_link: "https://github.com/AbhyudayaSharma/ChromaLock",
    languages:[FILTERS[9]],
    packages:[PACKAGES[26],PACKAGES[27],PACKAGES[28],PACKAGES[29],PACKAGES[30]]
  },


  {
    icon_path: "media/asl_detection.png",
    alt_name:"American Sign Langauge Detection",
    name: "ASL Detection",
    catchphrase: "Pose Estimation | Faster-RCNN | ASL | Text-to-Speech (TTS)",
    bulletpoints: ['Real-time letter based translation of american sign language (ASL) to english chracters using visual observation', 'Supports text to speech (TTS) options to dictate ASL inputs by users', 'Utilizes both Faster-RCNN and pose-estimation models for ASL classification'],
    github_link: "https://github.com/ShreyasRaman-01/CS1430_Final_Project",
    languages:[FILTERS[0]],
    packages:[PACKAGES[1], PACKAGES[7], PACKAGES[10], PACKAGES[0],PACKAGES[34], PACKAGES[35]]
  },

  
  {
    icon_path: "media/paleoai_icon.png",
    alt_name:"PaleoAI_icon",
    name: "PaleoAI: Taxonomical Identification",
    catchphrase: "Dataset Expansion | Generative Modelling",
    bulletpoints: ['Expanded existing dataset 8× by adding 300,000+ images, with unique taxonomies','New data improved model classification accuracy to >80%','Web-scraping Tool: scrapes online databases for image file-links; automatically saves images using a user-specified or auto-generated file structure','Taxonomic Lookup: an SQLite database used as a reference tool to filter family, genus and species names for the image dataset', 'Cycle-GAN: enhancing a Cycle-GAN model for translations between leaf and fossil images - used to generate synthetic training samples', 'Completed under Prof. Thomas Serre - Serre Labs' ],
    github_link: "https://github.com/serre-lab/paleoai_data",
    languages:[FILTERS[0],FILTERS[5]],
    packages:[PACKAGES[2],PACKAGES[5],PACKAGES[6],PACKAGES[7],PACKAGES[9]]
  },
  {
    icon_path: "media/COVID_icon.png",
    alt_name:"COVID_SIR_icon",
    name: "COVID-19 Infection Modelling",
    catchphrase: "SIR Model | Predicting Disease Spread",
    bulletpoints: ['SIR model simulates the spread of a disease within a population to forecast infected, deceased and susceptible members over time','Includes 5 broad tunable parameters (and over 20 finer tunable parameters) to define a small population (its composition and size) as well the infection','Predicts disease spread over the broader population (death rates, recovery rates etc...) and between/within particular subgroups (i.e. to monitor "disease hotspots" or "contact tracing")'],
    github_link: "https://github.com/ShreyasRaman-01/COVID-19_Disease_Modeling",
    languages: [FILTERS[6]],
    packages: []
  },
  {
    icon_path: "media/pathfinder_icon.png",
    alt_name:"Pathfinder_Icon",
    name: "Pathfinder 1.0",
    catchphrase: "Gridworld Search | BFS, DFS, A*, Greedy Search, Q-Learning, R-Max",
    bulletpoints: ['Multiple pathfinding algorithms (DFS, BFS, A* Search, Greedy Algorithm) and reinforcement learning algorithms (Q-Learning and R-Max) visualized on an easy to understand color-coded gridworld','Displays 4 types of tiles: \'start\' tiles [where the agent being], \'end\' tiles [the goal], \'wall\' tiles [where the agent cannot pass through], \'trap\' tiles [penalty tiles with high cost e.g. regions of high traffic] ', 'Setup the gridworld, pick your algorithm and let the agent run!'],
    github_link: "https://github.com/ShreyasRaman-01/Pathfinder_v1.0",
    languages: [FILTERS[0]],
    packages: [PACKAGES[0], PACKAGES[8],PACKAGES[25]]
  },
  {
    icon_path: "media/videogame_icon.png",
    alt_name:"Dashboard_Visualizer_Icon",
    name: "Data Dashboard Visualizer",
    catchphrase: "Kaggle Datasets: Video Game Sales | Interactive + Animated Dashboard",
    bulletpoints: ['A thematic HTML web-page that serves as a data dashboard','Built interactive and stylized graphs, pie-charts and scatter plots (with summary tooltips) using d3.js','Created interactive user input streams [text/button input] to filter displayed data or perform scatter point regression in real-time [with animation]','Performed and displayed statistical analysis (e.g. box-whisker plot) that adapts search/display based on filters selected - also using d3.js','Completed as part of project for CS1951A - Data Science'],
    github_link: "https://github.com/Shreyas-S-Raman/DashboardVisualizer",
    languages: [FILTERS[2],FILTERS[7]],
    packages: [PACKAGES[11],PACKAGES[12],PACKAGES[13],PACKAGES[14]]
  },
  {
    icon_path: "media/seamcarve_icon.png",
    alt_name:"SeamCarve_Icon",
    name: "SeamCarve 1.0",
    catchphrase: "Image Resizing | Pixel Importance",
    bulletpoints: ['Implementation of liquid rescaling of an image through content-aware resizing', 'A GUI that displays the (jpg, jpeg or png) image to be resized along with a slider to vary the number of \'vertical seams\' carved out of the image','Calculates pixel importance and performs intelligent removal of the \'k\' lowest importance seams in the image, allowing for the image to be downscaled','Completed as part of project for CS0160 - Introduction to Data Structures and Algorithms'],
    github_link: "https://www.github.com",
    languages: [FILTERS[1]],
    packages: [PACKAGES[3], PACKAGES[22]]
  },
  {
    icon_path: "media/shell_icon.png",
    alt_name:"Shell_Icon",
    name: "Shell",
    catchphrase: "A Custom UNIX Shell Implementation",
    bulletpoints: ['A job-control system that parses input (bash) shell commands (e.g. cd, rm, ln, exit, pwd, ls, chdir etc...)  and executes, with appropriate error-handling if needed','Handles any other shell-commands via child processes using the fork system command (execv())','Handles input/output redirections, multi-threaded command execution, foreground and background jobs and signal masking/safety','Handles "reaping" (removal/stopping) of terminated, stopped or signalled background jobs','Completed as part of project for CS0330 - Introduction to Computer Systems'],
    github_link: "https://www.github.com",
    languages: [FILTERS[4],FILTERS[8]],
    packages: [PACKAGES[16],PACKAGES[17],PACKAGES[18],PACKAGES[19],PACKAGES[20],PACKAGES[21]]
  },
  {
    icon_path: "media/flappybird_icon.png",
    alt_name:"Evolution_Icon",
    name: "Evolution",
    catchphrase: "Genetic Algorithm | Neural Network | FlappyBird",
    bulletpoints: ['A GUI to play FlappyBird (original single-player game) or let a genetic algorithm learn to play the game','Genetic Algorithm Implementation: using feed-forward neural net to train several \'FlappyBird\' agents and tracking \'fitness\' of agents; top-performing agents move to the next generation', 'Tunable Experiments: the generation/population size, mean gap between pipes and speed of the agents are all tunable to make the game more/less difficult','Neural Network Visulalization: GUI interface to visualize the dominant weights and inputs beind the best-performing agent in each generation','Completed as part of final project for CS1050 - Introduction to Object Oriented Programming'],
    github_link: "https://www.github.com",
    languages: [FILTERS[1]],
    packages: [PACKAGES[3], PACKAGES[22], PACKAGES[23], PACKAGES[4],PACKAGES[24]]
  }
]


const Projects = () => (
  <div className={styles.container}>
    <h2 className={styles.projectsTitle}>Recent Projects</h2>

    {Array.from(PROJECT_DETAILS.keys()).map((val, index) => (
      <ProjectBox key={index} packages={PROJECT_DETAILS[val].packages} filters={PROJECT_DETAILS[val].languages} icon={PROJECT_DETAILS[val].icon_path} alt_icon_name = {PROJECT_DETAILS[val].alt_name} github_link = {PROJECT_DETAILS[val].github_link} name = {PROJECT_DETAILS[val].name} catchphrase = {PROJECT_DETAILS[val].catchphrase} description = {PROJECT_DETAILS[val].bulletpoints}/>
    ))}


  </div>
);

export default Projects;
